module.exports = __webpack_public_path__ + "img/0.77db9c31.jpg";